import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "candidate-hall-session__status" }
const _hoisted_3 = { class: "candidate-hall-session__content" }
const _hoisted_4 = { class: "candidate-hall-session__heading" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "candidate-hall-session__tags" }
const _hoisted_7 = { class: "candidate-hall-session__mode" }
const _hoisted_8 = { class: "candidate-hall-session__permission" }
const _hoisted_9 = { class: "candidate-hall-session__time" }
const _hoisted_10 = { class: "is-publish" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "is-end" }
const _hoisted_14 = ["src"]

import { computed } from 'vue'
import { PilotAssessmentHallSession } from '@/service'
import CandidateButton from './ui/CandidateButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CandidateHallSessionCard',
  props: {
    session: {},
    status: {},
    statusLabel: {},
    entering: { type: Boolean }
  },
  emits: ["enter"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const tone = computed<'blue' | 'purple' | 'disabled'>(() => {
  if (props.status !== 'running') return 'disabled'
  return props.session.participateMode === 2 ? 'purple' : 'blue'
})

const actionLabel = computed(() => {
  if (props.status !== 'running') return props.statusLabel
  return props.session.qualified ? '开始考试' : '无考试权限'
})

const surfaceImage = computed(() => {
  if (tone.value === 'purple') return require('@/assets/candidate/hall-card-purple-tall.png')
  if (tone.value === 'disabled') return require('@/assets/candidate/hall-card-disabled-tall.png')
  return require('@/assets/candidate/hall-card-blue-tall.png')
})

const publishIcon = computed(() => {
  if (tone.value === 'disabled') {
    return require('@/assets/candidate/hall-publish-disabled@1x.png')
  }
  return require('@/assets/candidate/hall-publish@1x.png')
})

const startIcon = computed(() => {
  if (tone.value === 'purple') return require('@/assets/candidate/hall-clock-start-purple@1.5x.png')
  if (tone.value === 'disabled') return require('@/assets/candidate/hall-clock-start-disabled@1.5x.png')
  return require('@/assets/candidate/hall-clock-start-blue@1.5x.png')
})

const endIcon = computed(() => {
  if (tone.value === 'purple') return require('@/assets/candidate/hall-clock-end-purple@1.5x.png')
  if (tone.value === 'disabled') return require('@/assets/candidate/hall-clock-end-disabled@1.5x.png')
  return require('@/assets/candidate/hall-clock-end-blue@1.5x.png')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["candidate-hall-session", [
      `candidate-hall-session--${tone.value}`,
      { 'candidate-hall-session--unqualified': _ctx.status === 'running' && !_ctx.session.qualified },
    ]])
  }, [
    _createElementVNode("img", {
      class: "candidate-hall-session__surface",
      src: surfaceImage.value,
      alt: ""
    }, null, 8, _hoisted_1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.statusLabel), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", {
          title: _ctx.session.sessionName
        }, _toDisplayString(_ctx.session.sessionName), 9, _hoisted_5),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.session.participateMode === 2 ? '定向模式' : '公开模式'), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.session.qualified ? '可参加' : '不可参加'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, [
          _createElementVNode("img", {
            src: publishIcon.value,
            alt: ""
          }, null, 8, _hoisted_11),
          _createElementVNode("strong", null, "发布时间 " + _toDisplayString(_ctx.session.publishTime), 1)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("img", {
            src: startIcon.value,
            alt: ""
          }, null, 8, _hoisted_12),
          _createElementVNode("strong", null, "开始时间 " + _toDisplayString(_ctx.session.validStartTime), 1)
        ]),
        _createElementVNode("p", _hoisted_13, [
          _createElementVNode("img", {
            src: endIcon.value,
            alt: ""
          }, null, 8, _hoisted_14),
          _createElementVNode("strong", null, "结束时间 " + _toDisplayString(_ctx.session.validEndTime), 1)
        ])
      ]),
      _createVNode(CandidateButton, {
        class: "candidate-hall-session__action",
        block: "",
        disabled: !_ctx.session.canEnter || _ctx.entering,
        loading: _ctx.entering,
        debounce: false,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('enter', _ctx.session)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(actionLabel.value), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ])
  ], 2))
}
}

})